import axiosInstance from "../instance/axiosInstance";

class DashboardApi {
  static async tiles() {
    try {
      const response = await axiosInstance.get("/dashboard");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getOnboardingStatus() {
    try {
      const response = await axiosInstance.post("/onboarding-seen");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getAdvanceSearchResults(page, data){
    try {
      try {
        const response = await axiosInstance.get(`/global-search-records?page=${page}`, {
          params: data, // Pass as query parameters
        });
        if (response) {
          return response.data;
        }
      } catch (error) {
        return error;
      }
    } catch (error) {
      return error
    }
  }
  
}

export default DashboardApi;
